import { FC, useMemo } from "react";

import {
  NOTIFICATION_ACTION_TYPES,
  createNotificationAction,
} from "shared/ui/notifications/notification-generic/base-parts/actions";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

import { NotificationBase } from "@/modules/notifications/notification/base";
import { NotificationI } from "@/lib/types/notification";
import {
  describeTopTenDigest,
  describeTopTenDue,
} from "@/modules/top-ten/lib/copy";
import { openAccountDetails } from "@/helpers/account-details";
import Router from "@/helpers/router";

type NotificationTopTenPropsI = NotificationI & PropsWithClassNameI;

/** TopTenDue: a Top 10 lead's call-by time arrived. Opens the lead. */
export const NotificationTopTenDue: FC<NotificationTopTenPropsI> = (props) => {
  const { id, is_seen, created_at, className, top_ten_due } = props;
  const text = useMemo(() => describeTopTenDue(top_ten_due), [top_ten_due]);

  return (
    <NotificationBase
      id={id}
      isUnread={!is_seen}
      className={className}
      avatar={props}
      description={{ text: <>{text}</>, date: created_at }}
      actions={[
        createNotificationAction(
          NOTIFICATION_ACTION_TYPES.PRIMARY,
          "Open lead",
          () =>
            openAccountDetails({
              campaignId: top_ten_due?.campaign_id,
              accountId: top_ten_due?.account_id,
            })
        ),
      ]}
    />
  );
};

/** TopTenDigest: the caller's morning count. Opens Open pipeline. */
export const NotificationTopTenDigest: FC<NotificationTopTenPropsI> = (
  props
) => {
  const { id, is_seen, created_at, className, top_ten_digest } = props;
  const text = useMemo(
    () => describeTopTenDigest(top_ten_digest),
    [top_ten_digest]
  );

  return (
    <NotificationBase
      id={id}
      isUnread={!is_seen}
      className={className}
      avatar={props}
      description={{ text: <>{text}</>, date: created_at }}
      actions={[
        createNotificationAction(
          NOTIFICATION_ACTION_TYPES.PRIMARY,
          "Open pipeline",
          () => {
            window.location.href = Router.accounts();
          }
        ),
      ]}
    />
  );
};
